import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';

@Component({})
export default class LoadingReportCardComponent extends Vue {
  @Prop(Object) formModel: IResourceModel;

  loadingProcessNumber = 1;
  totalDuration = 5 * 60 * 1000;
  updateDuration = 2 * 60 * 1000;
  updateInterval = 1000;
  maxProgress = 100;
  intervalLoadingReportCard;
  timerStopLoadingReportCard;
  resetProgress = false;
  isShowReloading = false;

  mounted() {
    this.clearLoadingReport();
    this.handleClearTimeOutStopReportCard();
    if (this.formModel && this.formModel.isLoadingCard !== undefined && this.formModel.isLoadingCard === true) {
      this.loadingProcessNumber = 1;
      this.startProgress();
    }
  }

  beforeDestroy() {
    this.clearLoadingReport();
    this.handleClearTimeOutStopReportCard();
  }

  @Watch('formModel')
  onFormModelChange() {
    if (this.formModel && this.formModel.requestId !== undefined && this.formModel.isLoadingCard === true) {
      this.clearLoadingReport();
      this.handleClearTimeOutStopReportCard();
      this.loadingProcessNumber = 1;
      this.startProgress();
    }
  }

  clearLoadingReport() {
    this.resetProgress = true;
    this.isShowReloading = false;

    if (this.intervalLoadingReportCard) {
      clearInterval(this.intervalLoadingReportCard);
    }
  }

  startProgress() {
    this.intervalLoadingReportCard = setInterval(() => {
      if (this.resetProgress) {
        this.loadingProcessNumber = 1;
        this.resetProgress = false;
      } else {
        this.loadingProcessNumber += this.maxProgress / (this.updateDuration / this.updateInterval);
      }

      if (this.loadingProcessNumber >= this.maxProgress) {
        this.resetProgress = true;
        this.loadingProcessNumber = this.maxProgress;
      }
    }, this.updateInterval);

    this.timerStopLoadingReportCard = setTimeout(() => {
      clearInterval(this.intervalLoadingReportCard);
      this.isShowReloading = true;
    }, this.totalDuration);
  }

  handleReloadingReportCard() {
    this.handleClearTimeOutStopReportCard();
    this.clearLoadingReport();

    this.$nextTick(() => {
      setTimeout(() => {
        this.startProgress();
      }, 100);
    });
  }

  handleClearTimeOutStopReportCard() {
    if (this.timerStopLoadingReportCard) {
      clearTimeout(this.timerStopLoadingReportCard);
      this.timerStopLoadingReportCard = null;
    }
  }
  get generatedFirstText() {
    switch (this.formModel.type) {
      case 'REPORT':
        return this.$t('briefing.loadingCardAndWidget.reportCardNoBriefing.loadingMessage.firstTextReport');
      case 'JOURNALIST_NOTE':
        return this.$t('briefing.loadingCardAndWidget.reportCardNoBriefing.loadingMessage.firstTextJournalistNote');
      case 'SOCIAL_MEDIA':
        return this.$t('briefing.loadingCardAndWidget.reportCardNoBriefing.loadingMessage.firstTextSocialMedia');
      case 'PODCAST':
        return this.$t('briefing.loadingCardAndWidget.reportCardNoBriefing.loadingMessage.firstTextPodcast');
      default:
        return '';
    }
  }
}
